import { CategoryApiFacade } from "../category/category.api-facade";
import { JobType } from "./job-type.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class JobTypeApiFacade extends CategoryApiFacade<JobType> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<JobType> {
        return this.GET(`/accounts/${accountId}/jobtypes/${id}`, options)
            .map(object => new JobType(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<JobType>> {
        return this.CGET(`/accounts/${accountId}/jobtypes`, options)
            .map(objects => objects.map(object => new JobType(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-type/job-type.api-facade.ts